import { useState } from 'react';
import { m } from 'framer-motion';
import { styled, useTheme } from '@mui/material/styles';
import { Container } from '@mui/system';
import { Grid, Typography, FormControl, RadioGroup, FormControlLabel, Radio, Box } from '@mui/material';
import { PropTypes } from 'prop-types';
//  import { varFade } from '../../animate';
import MotionViewport from '../../animate/MotionViewport';
import CustomButton from '../Buttons/CustomButton';
import useLocales from '../../../hooks/useLocales';

Quiz.propTypes = {
  // title: PropTypes.string,
  data: PropTypes.array,
};

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3, 0),
  backgroundColor: theme.palette.background.paper,
}));

const QuizBox = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3, 3),
  borderRadius: '12px',
  border: `1px solid ${theme.palette.text.primary}`,
  // boxShadow: `0px 1px 8px ${theme.palette.text.secondary}`,
}));

const OurRadio = styled(Radio)(({ theme }) => ({
  color: theme.palette.text.primary,
  '& span svg': {
    fill: theme.palette.text.primary,
  },
}));

// const OurCheckbox = styled(Checkbox)(({ theme }) => ({
//   color: theme.palette.text.primary,
//   '& svg': {
//     fill: theme.palette.text.primary,
//   },
// }));

export default function Quiz({ data }) {
  const { translate } = useLocales();
  const theme = useTheme();

  const [actualNum, setActual] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const isQuestions = data.every((item) => item.question.length);

  const quizResult = () => {
    if (actualNum === data.length - 1) {
      if (answers[actualNum] && answers[actualNum].length > 0) {
        let res = 0;
        data.forEach((item, index) => {
          if (item.correctAnswer === answers[index]) {
            res += 1;
          }
        });
        setResult(`${res}`);
      } else {
        setError(translate('articles.noAnswer'));
        setTimeout(() => {
          setError('');
        }, 3000);
      }
    }
  };

  const prevQuestion = () => {
    setActual((old) => (old > 0 ? old - 1 : old));
  };

  const nextQuestion = () => {
    if (answers[actualNum]) {
      setActual((old) => (old < data.length - 1 ? old + 1 : old));
    } else {
      setError(translate('articles.noAnswer'));
      setTimeout(() => {
        setError('');
      }, 3000);
    }
  };

  const radioChangeHandler = (e) => {
    if (!answers[actualNum]) {
      const temp = [...answers];
      temp[actualNum] = e.target.value;
      setAnswers(temp);
    }
  };

  const restartQuiz = () => {
    setActual(0);
    setAnswers([]);
    setResult(null);
  };

  const getCorrentAnswer = (option) => {
    if (answers[actualNum] && data[actualNum].correctAnswer === option.id) {
      return '#E1AA00';
    }
    return theme.palette.background.paper;
  };

  // const checkboxChangeHandler = (e) => {
  //   const temp = [...answers];
  //   if (answers[actualNum].includes(e.target.value)) {
  //     temp[actualNum] = answers[actualNum].filter((i) => i !== e.target.value);
  //   } else {
  //     temp[actualNum].push(e.target.value);
  //   }
  //   setAnswers(temp);
  // };

  return (
    <>
      {isQuestions && data.length > 0 && (
        <RootStyle>
          <Container component={MotionViewport} sx={{ position: 'relative', height: '100%' }}>
            <m.div /* variants={varFade().inUp} */>
              <QuizBox container>
                <Grid item xs={7} sm={10} className="text-left">
                  <Typography variant="h4" sx={{ padding: '6px' }}>
                    {translate('articles.quizTitle')}
                    {/* {title} */}
                  </Typography>
                </Grid>
                {!result && (
                  <Grid item xs={5} sm={2} className="text-right">
                    <Typography variant="h5" sx={{ padding: '6px' }}>
                      {actualNum + 1} {translate('articles.from')} {data.length}
                    </Typography>
                  </Grid>
                )}

                {!result && (
                  <Grid item xs={12} sx={{ padding: '16px 16px 0px 16px' }} className="text-left">
                    <Typography variant="subtitle1" sx={{ padding: '6px' }}>
                      {actualNum + 1}. {data[actualNum]?.question}
                    </Typography>
                  </Grid>
                )}

                <Grid item xs={12} sx={{ padding: '0px 16px 8px 16px' }} className="text-left">
                  {result ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 4,
                        flexDirection: 'column',
                      }}
                    >
                      <Typography variant="subtitle1" sx={{ padding: '2px', fontSize: '17px' }}>
                        {`${Number(result)}/${data.length}`}
                      </Typography>
                      <Typography variant="subtitle1" sx={{ padding: '6px', fontSize: '30px' }}>
                        {Number(result) === data.length && translate('articles.result2')}
                        {Number(result) === data.length - 1 && Number(result) > 0 && translate('articles.result3')}

                        {Number(result) <= data.length - 2 && Number(result) > 0 && translate('articles.result4')}
                        {Number(result) === 0 && translate('articles.result5')}
                        {/* {translate('articles.result')} {result} {translate('articles.from')} {data.length} */}
                      </Typography>
                    </Box>
                  ) : (
                    <FormControl>
                      {data[actualNum]?.answers.length > 0 && (
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          value={answers[actualNum] || ''}
                          name="radio-buttons-group"
                          onChange={radioChangeHandler}
                        >
                          {data[actualNum].answers.map((option) => (
                            <FormControlLabel
                              key={option.id}
                              value={option.id}
                              control={<OurRadio />}
                              label={option.text}
                              style={{
                                backgroundColor: getCorrentAnswer(option),
                                padding: '8px',
                                borderRadius: '8px',
                                margin: '2px 0px',
                              }}
                            />
                          ))}
                        </RadioGroup>
                      )}
                    </FormControl>
                  )}
                </Grid>

                <Grid item xs={12} className="text-right">
                  {result ? (
                    <CustomButton text="articles.restart" primary action={restartQuiz} style={{ margin: '8px 8px' }} />
                  ) : (
                    <>
                      {actualNum > 0 && (
                        <CustomButton
                          text="articles.prevQuestion"
                          primary
                          action={prevQuestion}
                          style={{ margin: '8px 8px' }}
                        />
                      )}
                      {actualNum < data.length - 1 && (
                        <CustomButton
                          text="articles.nextQuestion"
                          primary
                          action={nextQuestion}
                          style={{ margin: '8px 8px' }}
                        />
                      )}
                      {actualNum === data.length - 1 && (
                        <CustomButton
                          text="articles.resultQuiz"
                          primary
                          action={quizResult}
                          style={{ margin: '8px 8px' }}
                        />
                      )}
                    </>
                  )}
                  {/* {actualNum < data.length - 1 && (
                <CustomButton
                  text="articles.nextQuestion"
                  primary
                  action={nextQuestion}
                  style={{ margin: '8px 8px' }}
                />
              )}
              {actualNum === data.length - 1 && (
                <CustomButton text="articles.resultQuiz" primary action={quizResult} style={{ margin: '8px 8px' }} />
              )} */}
                </Grid>
                {error.length > 0 && (
                  <Grid item xs={12} sx={{ padding: '8px 16px 0px 16px' }} className="text-right">
                    <Typography variant="subtitle1" sx={{ color: '#FF4842' }}>
                      {error}
                    </Typography>
                  </Grid>
                )}
              </QuizBox>
            </m.div>
          </Container>
        </RootStyle>
      )}
    </>
  );
}
